/**
 * @license lucide-vue-next v0.485.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import { h } from 'vue';
import Icon from './Icon.js';

const createLucideIcon = (iconName, iconNode) => (props, { slots }) => h(
  Icon,
  {
    ...props,
    iconNode,
    name: iconName
  },
  slots
);

export { createLucideIcon as default };
//# sourceMappingURL=createLucideIcon.js.map
